import * as React from 'react';

import DateRanger from '../../containers/DateRanger/DateRanger';
import UserExplorerFilterRender from '../../containers/UserCard/UserExplorerFilterRender';

import eventCategories from '../../utils/userExplorerTable';

import * as calendar from '../../assets/image/Calendar.png';

interface Props {
  hideDatePicker: boolean;
  userExplorerisSuccess: any[];
  userExplorerFilter: (value: string, checked: boolean) => void;
  currentCategory: any;
}

const DateWrapper = (props: Props) => {

  const {
    hideDatePicker,
    userExplorerisSuccess,
    userExplorerFilter,
    currentCategory,
  } = props;

  const handleChange = (e) => {
    userExplorerFilter(e.target.value, e.target.checked);
  };

  const renderFilter = (param) => {
    return eventCategories.map((category, index) => {
      if (category.toLowerCase().includes(param)) {
        return (
          <div
            className='user-explorer-events'
            key={index}>
            <input
              className='form-check-input'
              type='checkbox'
              value={category}
              onChange={handleChange}
              checked={currentCategory[category] || currentCategory['All']}
            />
            <label>{category}</label>
          </div>
        );
      }
      return null;
    });
  };

  return (
    <div className='date-wrapper' >
      {
        !hideDatePicker &&
          <div className='user-card-dates'>
            <div className='d-flex dates-head align-center'>
              <img
                className='dates-img'
                src={calendar} />
              <div className='user-card-dates-head'>{'Date Range'}</div>
            </div>
            <DateRanger />
          </div>
      }
      {
        // @ts-ignore
        !!userExplorerisSuccess.length > 0 &&
        <UserExplorerFilterRender
          renderFilter={(param) => renderFilter(param)}
        />
      }
    </div>
  );
};

export default React.memo(DateWrapper);
